<template>
  <md-card-actions>
    <p class="md-layout-item">
      Mostrando
      <strong>
        {{ pageSize * (localCurrentPage - 1) }}-{{
        pageSize * localCurrentPage
        }}
      </strong>
      de
      <strong>{{ total }}</strong> entradas
    </p>

    <pagination
      class="pagination-no-border pagination-success"
      v-model="localCurrentPage"
      :per-page="pageSize"
      :total="total"
    />
  </md-card-actions>
</template>

<script>
import Pagination from "@/components/Pagination";

export default {
  name: "TablePagination",

  props: {
    paginationInfo: {
      type: Object,
      required: false,
      default: null,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    tableData: {
      type: Array,
      required: true,
    },
    value: {
      type: Array,
      required: false,
      default: () => [],
    },
    currentPage: {
      type: Number,
      default: 1,
    },
  },

  components: {
    Pagination,
  },

  computed: {
    queriedData() {
      const data = this.tableData;
      return data.slice(this.from, this.to);
    },

    to() {
      const { paginationInfo, pageSize } = this;
      if (paginationInfo) {
        return this.tableData.length;
      } else {
        const { localCurrentPage: currentPage } = this;
        return currentPage * pageSize;
      }
    },
    from() {
      const { paginationInfo, pageSize } = this;
      if (paginationInfo) {
        return 0;
      } else {
        const { localCurrentPage: currentPage } = this;
        return pageSize * (currentPage - 1);
      }
    },
    total() {
      if (this.paginationInfo) {
        const paginationInfo = this.paginationInfo;
        return (paginationInfo && paginationInfo.count) || 0;
      } else {
        const { tableData } = this;
        return tableData ? tableData.length : 0;
      }
    },

    localPaginationInfo: {
      get() {
        const { pageSize: perPage, total } = this;
        const { localCurrentPage: currentPage } = this;
        return {
          count: total,
          next: (currentPage + 1) * perPage <= total ? currentPage + 1 : null,
          previous: currentPage > 1 ? currentPage - 1 : null,
        };
      },
      set(value) {
        const { count, next, previous, results } = value || {};
        this.localCurrentPage = !previous ? 1 : previous + 1;
      },
    },
  },

  watch: {
    queriedData: {
      immediate: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    localCurrentPage(value) {
      // this.$emit('updatedCurrentPage', value)
      this.$emit("update:currentPage", value);
    },
    localPaginationInfo: {
      // deep:true,
      // immediate: true,
      handler(value = {}) {
        const { paginationInfo: pInfo } = this;
        if (!pInfo) {
          return;
        }
        if (
          ["count", "next", "previous"].some(
            (k) => (pInfo[k] && pInfo[k]) != (value[k] && value[k])
          )
        ) {
          this.$emit("update:paginationInfo", value);
        }
      },
    },
    currentPage(value) {
      this.localCurrentPage = value;
    },
  },

  data() {
    return {
      localCurrentPage: 1,
    };
  },
};
</script>

<style lang="less" scoped>
.pagination-no-border {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Tables/TablePagination.vue